<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area history">
      <img
        :src="`${resources}img/img-top-sub-title5.jpg`"
        alt=""
        v-if="device === 'mo'"
      />
      <div class="tit_area">
        <div class="sub_tit">주요연혁</div>
        <div class="sub_txt" v-if="device === 'mo'">
          1971년 설립 이후 혁신을 거듭하여 <br />PC(Precast Concrete) 관련 건설
          분야에서 <br />선도기업으로 성장해왔습니다.
        </div>
        <div class="sub_txt" v-else>
          1971년 설립 이후 혁신을 거듭하여 PC(Precast Concrete)<br />
          관련 건설 분야에서 선도기업으로 성장해왔습니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents" v-if="device === 'mo'">
      <div>
        <ul class="history_item2">
          <li>
            <div class="hs_dt">2024<span>년</span></div>
            <div class="hs_dd">
              <ul>
                <li>한국오션플랫폼㈜ 사명 변경</li>
                <li>LS그룹 계열 분리</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="hs_dt">2021<span>년</span></div>
            <div class="hs_dd">
              <ul>
                <li>㈜한성과 한성PC건설㈜ 합병</li>
                <li>존속법인 한성PC건설㈜ 출범</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="hs_dt">2020<span>년</span></div>
            <div class="hs_dd">
              <ul>
                <!-- 2021-11-09 : 문구 수정 -->
                <li>
                  아산PC공장 HCS 생산 LINE 설비 <br />(27 BED, 국내 최대)<br />*
                  HCS : Hollow Core Slab
                </li>
                <!-- //2021-11-09 : 문구 수정 -->
              </ul>
            </div>
          </li>
          <li>
            <div class="hs_dt">2015<span>년</span></div>
            <div class="hs_dd">
              <ul>
                <li>삼성물산 음성PC공장 인수</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="hs_dt">2009<span>년</span></div>
            <div class="hs_dd">
              <ul>
                <li>㈜한성에서 물적 분할하여 한성PC건설㈜ 설립</li>
                <li>LS그룹으로 편입</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="hs_dt">2004<span>년</span></div>
            <div class="hs_dd">
              <ul>
                <li>㈜한성과 세일산업㈜ 합병</li>
                <li>존속법인 ㈜한성 출범</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="hs_dt">1996<span>년</span></div>
            <div class="hs_dd">
              <ul>
                <li>㈜한성 아산PC공장 준공</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="hs_dt">1978<span>년</span></div>
            <div class="hs_dd">
              <ul>
                <li>㈜한성으로 상호 변경</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="hs_dt">1971<span>년</span></div>
            <div class="hs_dd">
              <ul>
                <li>
                  한성프리훼브㈜ 설립 (대한주택공사와 일본 대성건설㈜ 합작)
                </li>
                <li>판교PC공장 준공</li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="sub_contents" v-else>
      <!-- 주요연혁 -->
      <!-- 주요연혁 -->
      <div>
        <ul class="history_con">
          <li>
            <dl>
              <dt>2024년</dt>
              <dd>
                <p>한국오션플랫폼㈜ 사명 변경</p>
                <p>LS그룹 계열 분리</p>
              </dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt>2021년</dt>
              <dd>
                <p>㈜한성과 한성PC건설㈜ 합병</p>
                <p>존속법인 한성PC건설㈜ 출범</p>
              </dd>
            </dl>
          </li>
          <!-- 2021-11-05 : 수정예정 -->
          <li>
            <dl>
              <dt>2020년</dt>
              <dd>
                <p>아산PC공장 HCS 생산 LINE 설비 (27 BED, 국내 최대)</p>
                <p>*HCS : Hollow Core Slab</p>
              </dd>
            </dl>
          </li>
          <!-- //2021-11-05 : 수정예정 -->
          <li>
            <dl>
              <dt>2015년</dt>
              <dd>
                <p>삼성물산 음성PC공장 인수</p>
              </dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt>2009년</dt>
              <dd>
                <p>㈜한성에서 물적 분할하여 한성PC건설㈜ 설립</p>
                <p>LS그룹으로 편입</p>
              </dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt>2004년</dt>
              <dd>
                <p>㈜한성과 세일산업㈜ 합병</p>
                <p>존속법인 ㈜한성 출범</p>
              </dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt>1996년</dt>
              <dd>
                <p>㈜한성 아산PC공장 준공</p>
              </dd>
            </dl>
          </li>

          <li>
            <dl>
              <dt>1978년</dt>
              <dd>
                <p>㈜한성으로 상호 변경</p>
              </dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt>1971년</dt>
              <dd>
                <p>한성프리훼브㈜ 설립 (대한주택공사와 일본 대성건설㈜ 합작)</p>
                <p>판교PC공장 준공</p>
              </dd>
            </dl>
          </li>
        </ul>
      </div>
      <!-- //주요연혁 -->

      <!-- //주요연혁 -->
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';
export default {
  mixins: [page]
};
</script>

<style lang="scss" scoped></style>
